<template>
  <div class="qiu">
    <el-upload
      action=""
      :show-file-list="false"
      :http-request="doUpload"
      :before-upload="beforeUpload"
      accept="image/*"
    >
      <el-button size="small" :loading="uploading" icon="el-icon-upload2">
        {{ value ? "Replace image" : "Upload image" }}
      </el-button>
    </el-upload>

    <div v-if="value" class="qiu__current">
      <el-tag size="mini" type="success" class="qiu__name">{{ value }}</el-tag>
      <el-button size="mini" type="text" class="qiu__remove" @click="clear">remove</el-button>
    </div>
  </div>
</template>

<script>
import APIOfferQuestions from "@/api/modules/offer-questions";

export default {
  props: {
    // current file_name stored on the question / answer
    value: { type: String, default: "" },
    // which endpoint to hit
    target: { type: String, default: "question", validator: (v) => ["question", "answer"].includes(v) },
  },
  data() {
    return { uploading: false };
  },
  methods: {
    beforeUpload(file) {
      const isImage = file.type && file.type.startsWith("image/");
      if (!isImage) {
        this.$notify({ type: "warning", title: "Only image files are allowed" });
      }
      return isImage;
    },
    async doUpload({ file }) {
      this.uploading = true;
      try {
        const fn =
          this.target === "answer"
            ? APIOfferQuestions.uploadAnswerImage
            : APIOfferQuestions.uploadQuestionImage;
        const response = await fn(file);
        const data = response && response.data ? response.data : {};
        const fileName = (data.data && data.data.file_name) || data.file_name || data.fileName;
        if (!fileName) {
          throw new Error("No file_name in upload response");
        }
        this.$emit("input", fileName);
        this.$notify({ type: "success", title: "Image uploaded" });
      } catch (e) {
        this.$notify({ type: "warning", title: "Error uploading image" });
      } finally {
        this.uploading = false;
      }
    },
    clear() {
      this.$emit("input", "");
    },
  },
};
</script>

<style scoped>
.qiu__current {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.qiu__name {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.qiu__remove {
  color: #f56c6c;
  padding: 0;
}
</style>
